export default __webpack_public_path__ + "static/media/NA.c781556a.svg";